import React from "react";
import Header from "../../Components/Header/Header";
import FooterNorand1 from "../../Components/FooterNorand/FooterNorand1";
import ManualPage from "../../Components/ManualPage/ManualPage";
import MonoManualMK2 from "../../Components/ManualPage/MonoManualMK2";

class MonoManualPage extends React.Component {
  render() {
    return (
      <>
        <div className="termsCondTop">
          <Header />
          <ManualPage manualData={MonoManualMK2} currentSection={0} />
          <FooterNorand1 />
        </div>
      </>
    );
  }
}

export default MonoManualPage;
